"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_view_1 = require("prosemirror-view");
var basic_ctrl_1 = require("../basic-ctrl");
var transEvents = [
    'transformPastedHTML',
    'transformPastedText',
    'clipboardTextParser',
    'transformPasted'
];
var editable = true;
var transEventChain = function (editor, handles) {
    var content = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        content[_i - 2] = arguments[_i];
    }
    // @ts-ignore
    if (!editor.view.editable)
        return content[0];
    return handles.reduce(function (res, handle) {
        res = handle(editor, res);
        return res;
    }, content[0]);
};
var chainEvent = function (event, editor, handlers) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (transEvents.includes(event)) {
        return transEventChain.apply(void 0, __spreadArrays([editor, handlers], args));
    }
    // @ts-ignore
    if (!editor.view.editable)
        return false;
    return handlers.some(function (handler) { return handler.apply(void 0, __spreadArrays([editor], args)); });
};
// 用chainEvent包装事件处理
var wrapEvent = function (handlers, editor) {
    return Object.keys(handlers).reduce(function (result, event) {
        var handler;
        if (event === 'handleDOMEvents') {
            var collectHandlers_1 = handlers[event].reduce(function (res, eventHandler) {
                Object.keys(eventHandler).forEach(function (domEvent) {
                    if (!res[domEvent]) {
                        res[domEvent] = [eventHandler[domEvent]];
                    }
                    else {
                        res[domEvent].push(eventHandler[domEvent]);
                    }
                });
                return res;
            }, {});
            handler = Object.keys(collectHandlers_1).reduce(function (res, domEvent) {
                res[domEvent] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return chainEvent.apply(void 0, __spreadArrays([domEvent,
                        editor,
                        collectHandlers_1[domEvent]], args));
                };
                return res;
            }, {});
        }
        else {
            handler = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return chainEvent.apply(void 0, __spreadArrays([event,
                    editor,
                    handlers[event]], args));
            };
        }
        // @ts-ignore
        result[event] = handler;
        return result;
    }, {});
};
var formatProps = function (propsList, editor) {
    // 收集props中所有事件处理
    var handlers = propsList.reduce(function (res, props) {
        Object.keys(props).forEach(function (event) {
            if (Array.isArray(res[event])) {
                // @ts-ignore
                res[event].push(props[event]);
            }
            else {
                // @ts-ignore
                res[event] = [props[event]];
            }
        });
        return res;
    }, {});
    return wrapEvent(handlers, editor);
};
var key = new prosemirror_state_1.PluginKey('customControl');
var createPlugin = function (props) {
    return new prosemirror_state_1.Plugin({
        key: key,
        props: props,
        state: {
            init: function () {
                return prosemirror_view_1.DecorationSet.empty;
            },
            apply: function (tr, set) {
                var data = tr.getMeta(basic_ctrl_1.BSControlKey);
                if (data) {
                    editable = data.editable;
                }
                return set;
            }
        }
    });
};
exports.CreateCustomCtrlPlugin = function (configs, editor) {
    var propsConfigs = configs.reduce(function (res, config) {
        if (config.props) {
            res.push(config.props);
        }
        return res;
    }, []);
    var props = {};
    if (propsConfigs.length) {
        props = formatProps(propsConfigs, editor);
    }
    return createPlugin(props);
};
//# sourceMappingURL=index.js.map